<template>
	<div class="page" v-loading="loading">
		<div class="breadcrumb">
			<el-breadcrumb separator-class="el-icon-arrow-right">
				<el-breadcrumb-item>订单</el-breadcrumb-item>
				<el-breadcrumb-item>全部订单</el-breadcrumb-item>
			</el-breadcrumb>
		</div>

		<el-row>
			<el-col :span="18">
				<el-form :inline="true" class="demo-form-inline">
					<el-form-item>
						<el-date-picker size="mini" v-model="filter.date_range" type="daterange"
							value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期"
							end-placeholder="结束日期">
						</el-date-picker>
					</el-form-item>
					<el-form-item>
						<el-input v-model="filter.keyword" placeholder="搜索订单号 / 昵称 / 手机号" size="mini" clearable
							style="width: 200px;"></el-input>
					</el-form-item>
					<el-form-item>
						<el-checkbox-group v-model="filter.status" size="mini">
							<el-checkbox :label="0">待付款</el-checkbox>
							<el-checkbox :label="1">已付款</el-checkbox>
							<el-checkbox :label="2">已开卡</el-checkbox>
							<el-checkbox :label="3">已发货</el-checkbox>
							<el-checkbox :label="4">已完成</el-checkbox>
							<el-checkbox :label="5">退款中</el-checkbox>
							<el-checkbox :label="6">已退款</el-checkbox>
							<el-checkbox :label="7">已取消</el-checkbox>
							<el-checkbox :label="9">团单</el-checkbox>
						</el-checkbox-group>
					</el-form-item>
					<el-form-item>
						<el-button icon="el-icon-search" type="primary" @click="onSearch" size="mini">查询</el-button>
						<el-button icon="el-icon-refresh" type="success" size="mini" @click="onRefresh">刷新</el-button>
					</el-form-item>
				</el-form>
			</el-col>
			<el-col :span="6" style="text-align: right;">
				<el-button type="success" size="mini" icon="el-icon-circle-plus-outline" @click="showBill">开票
				</el-button>
			</el-col>
		</el-row>

		<el-tabs v-model="actTableType" type="card" @tab-click="changeTab">
			<el-tab-pane :label="'全部('+totalData.all_count+')'" name="-1"></el-tab-pane>
			<el-tab-pane :label="'未付款('+totalData.unpay+')'" name="0"></el-tab-pane>
			<el-tab-pane :label="'已付款('+totalData.ispay+')'" name="1"></el-tab-pane>
			<el-tab-pane :label="'已发卡('+totalData.sendCard+')'" name="2"></el-tab-pane>
			<el-tab-pane :label="'已发货('+totalData.sendgoods+')'" name="3"></el-tab-pane>
			<el-tab-pane :label="'已完成('+totalData.isFinish+')'" name="4"></el-tab-pane>
			<el-tab-pane :label="'退款中('+totalData.refunding+')'" name="5"></el-tab-pane>
			<el-tab-pane :label="'已退款('+totalData.refunded+')'" name="6"></el-tab-pane>
			<el-tab-pane :label="'已取消('+totalData.cancel+')'" name="7"></el-tab-pane>
			<el-tab-pane :label="'团单('+totalData.group+')'" name="9"></el-tab-pane>

		</el-tabs>

		<div class="order_table" v-for="(order,i) in tableData" :key="order.id">
			<div class="order">
				<div class="order-header">
					<div class="order-no">
						<span class="index">
							#{{i+1}}
						</span>
						<span>
							<el-tag effect="dark" :color="order.store.platform.color" size="mini">{{order.store.title}}
							</el-tag>
						</span>
						<span>订单号：{{order.order_no}} 录单：{{order.creater?order.creater.adminer:'--'}}</span>
					</div>
					<span class="order-create">
						下单时间：{{order.created_at}}
					</span>
					<span class="pay-time flex">
						支付时间：{{order.payed_at?order.payed_at:'-'}}
						<el-divider direction="vertical"></el-divider>

						<el-popover placement="top" width="220" trigger="manual" v-model="order.adminShow">
							<el-link type="primary" slot="reference" @click="setOrderAdminer(order.id)"><span
									style="font-size:12px;">{{order.modifications.length>0?order.modifications[0].adminer:'引导人'}}
									<i class="el-icon-edit"></i></span></el-link>
							<div style="text-align: right; margin: 0">
								<el-button size="mini" type="text" @click="order.adminShow = false">取消</el-button>
								<el-button type="primary" size="mini" @click="order.adminShow = false">确定</el-button>
							</div>
						</el-popover>
					</span>
					<div class="order-operation">
						<div class="flex" style="justify-content: space-around;">
							<span>操作</span>
							<span v-if="order.bills.length == 0">
								<el-checkbox v-model="billOrders" :label="order">发票</el-checkbox>
							</span>
							<span v-else @click="showOrderBill(order.bills[0])">查看发票</span>
						</div>
					</div>
				</div>
				<div class="order-body">
					<div class="order-items">
						<div class="order-item" v-for="orderItem in order.order_items" :key="orderItem.id">
							<div class="good">
								<div class="good-img">
									<el-image :src="orderItem.thumb" fit="fill"></el-image>
								</div>
								<div class="good-info">
									<div class="good-title">
										{{orderItem.title}}
										<el-tag type="danger" size="mini" style="margin-right:5px;"
											v-if="orderItem.is_gift==1">赠送</el-tag>

									</div>
									<div class="good-price">
										{{orderItem.payment}} x {{orderItem.num}}
										<el-button v-if="power_change_goods==1" type="warning" icon="el-icon-edit"
											circle style="padding: 5px;"
											@click="showItemEditFunc(orderItem,order.payment)"></el-button>
									</div>

								</div>
								<div class="good-verifies">
									<div class="verify" v-for="verify in orderItem.verify_codes" :key="verify.id">
										<div class="verify-header">
											<div>
												<tableEditInput propsName="code" :info="verify"
													url="order/verify_codes/quick"></tableEditInput>
												<el-button v-if="power_change_goods==1" effect="dark" size="mini"
													slot="reference" type="warning"
													style="padding: 5px;margin-right:5px"
													@click="showItemEditFunc(orderItem,order.payment,verify.id)">改套餐
												</el-button>
												<el-popconfirm v-if="verify.code && verify.status==0" placement="top"
													confirm-button-text='核销' cancel-button-text='取消' title="确定已核销吗？"
													@confirm="writeOff(verify.id)">
													<el-button type="success" effect="dark" size="mini" slot="reference"
														style="padding: 5px">核销</el-button>
												</el-popconfirm>
												<span v-if="verify.status==1">核销时间：{{verify.verify_at}}</span>

												<div v-for="item in verify.children" :key="item.id">
													<div class="good">
														<div class="good-img">
															<el-image :src="item.order_item.thumb" fit="fill">
															</el-image>
														</div>
														<div class="good-info">
															<div class="good-title">{{item.order_no}}
																<el-tag v-if="item.store" effect="dark"
																	:color="item.store.platform.color" size="mini"
																	style="padding:2;font-size:12px">
																	{{item.store.title}}</el-tag>
															</div>
															<div class="good-title">{{item.code}}</div>
															<div class="good-title">
																{{item.order_item.title}}
															</div>
															<div class="good-price">
																{{item.order_item.payment}}
															</div>
														</div>
													</div>
												</div>
											</div>
											<div>
												<span style="display: -webkit-box;">引导人:
													{{order.modifications&&order.modifications.length>0?order.modifications[0].adminer:'--'}}
												</span>
												<span style="display: -webkit-box;">核销人:
													{{verify.modifications&&verify.modifications.length>0?verify.modifications[0].adminer:'--'}}</span>
												<span style="display: -webkit-box;">预约人:
													{{verify && verify.appointments && verify.appointments.length>0?(verify.appointments[0].modifications && verify.appointments[0].modifications.length>0?verify.appointments[0].modifications[0].adminer:'--'):'--' }}</span>
											</div>
											<span>
												<orderBind :info="verify" @subQuick="getTableData"></orderBind>
												<div v-if="verify.parent">
													<div>{{verify.parent.order_no}}
														<el-tag v-if="verify.parent.store" effect="dark"
															:color="verify.parent.store.platform.color" size="mini"
															style="padding:2;font-size:12px">
															{{verify.parent.store.title}}</el-tag>
													</div>
													<div v-for="appointment in verify.parent.appointments"
														:key="appointment.id">
														{{appointment.realname}} {{appointment.visit_time}}
														{{appointment.status_text}}
													</div>
												</div>
											</span>
										</div>
										<div class="verify-body" v-if="!verify.parent && verify.code">
											<div>
												<el-link v-if="verify.appointments.length == 0" type="primary"
													icon="el-icon-date" @click="setAppointment(verify, 0)">预约</el-link>
												<span class="appointment-info" v-else>
													<i class="el-icon-user"></i> {{verify.appointments[0].realname}}
													<i class="el-icon-date"></i> {{verify.appointments[0].visit_time}}
													<label
														v-if="verify.appointments[0].shop && verify.appointments[0].shop.area">
														<i class="el-icon-place"></i>
														{{verify.appointments[0].shop.area.name}} </label>

													<el-tag type="danger" size="mini" effect="dark"
														v-if="verify.appointments[0].sex == 2"><i
															class="el-icon-female"></i> 女</el-tag>
													<el-tag type="success" size="mini" effect="dark" v-else><i
															class="el-icon-male"></i> 男</el-tag>
													<el-tag color="#DAD787" size="mini" effect="dark"
														v-if="verify.appointments[0].merry == 2"><i
															class="el-icon-user"></i> 未婚</el-tag>
													<el-tag color="#E59191" size="mini" effect="dark" v-else><i
															class="el-icon-user"></i> 已婚</el-tag>
												</span>
												<br />
												<!-- <el-divider direction="vertical"></el-divider> -->
												<span v-if="verify.card">
													<i class="el-icon-bank-card"></i> {{verify.card.code}} / <i
														class="el-icon-key"></i> {{verify.card.passwd}}
													[{{verify.card.channel?verify.card.channel.title:''}} /
													{{verify.card.sex_text}} / {{verify.card.city?verify.card.city:''}}]

												</span>
												<el-link type="primary" icon="el-icon-bank-card" v-else
													@click="openCardShow(verify.id, orderItem.good_id)">开卡</el-link>
												<div style="display: inline-block;">
													<el-tag size="mini"
														v-if="verify.appointments.length > 0 && (verify.appointments[0].status ==3 || verify.appointments[0].status ==4)">
														已体检</el-tag>
													<el-popconfirm
														v-if="verify.card && (verify.appointments.length == 0 || (verify.appointments[0].status !=3 && verify.appointments[0].status !=4))"
														placement="top" confirm-button-text='回收' cancel-button-text='取消'
														icon-color="red" title="确定回收吗？"
														@confirm="onRecovery(verify.id, verify.card.id)"
														class="btn-pop">
														<el-button type="danger" effect="dark" size="mini"
															slot="reference" style="padding: 5px">回收</el-button>
													</el-popconfirm>
												</div>
											</div>
											<el-button-group
												v-if="orderItem.is_multiple && verify.appointments.length > 0">
												<el-button size="mini" type="info" @click="changeVisitDate(item.id)"
													v-for="item in verify.appointments" :key="item.id">
													{{item.visit_time}}</el-button>
											</el-button-group>
										</div>
									</div>
									<div v-if="orderItem.more_codes && orderItem.more_codes==1"
										style=" color: #999da0; text-align: center; padding: 5px;  text-decoration: underline;"
										@click="getMoreCode(order.id,orderItem.id,order.platform_id)">查看更多</div>
									<div class="verify" v-if="orderItem.is_real">
										<div class="verify-kd" v-if="orderItem.kd_name">
											<el-popover placement="top" width="200" trigger="manual"
												v-model="orderItem.kdShow">
												<el-tag size="mini" type="info" effect="dark" slot="reference"
													@click="orderItem.kdShow = !orderItem.kdShow">
													{{orderItem.kd_name}}：{{orderItem.kd_no}}</el-tag>
												<div class="row-edit-input">
													<div class="quick-form">
														<el-input v-model="orderItem.kd_name" placeholder="填写快递公司"
															size="mini" clearable></el-input>
													</div>
													<div class="quick-form">
														<el-input v-model="orderItem.kd_no" placeholder="填写快递单号"
															size="mini" clearable></el-input>
													</div>
												</div>
												<div style="text-align: right; margin: 0">
													<el-button size="mini" type="text"
														@click="orderItem.kdShow = false">取消</el-button>
													<el-button type="primary" size="mini"
														@click="setOrderItemKd(orderItem)">确定</el-button>
												</div>
											</el-popover>

											<span v-if="orderItem.is_self">
												<el-popover placement="top" width="200" trigger="manual"
													v-model="orderItem.hjShow" v-if="orderItem.hj_name">
													<el-tag size="mini" type="success" effect="dark"
														v-if="orderItem.is_self" slot="reference"
														@click="orderItem.hjShow = !orderItem.hjShow">
														{{orderItem.hj_name}}:{{orderItem.hj_no}}</el-tag>
													<div class="row-edit-input">
														<div class="quick-form">
															<el-input v-model="orderItem.hj_name" placeholder="填写快递公司"
																size="mini" clearable></el-input>
														</div>
														<div class="quick-form">
															<el-input v-model="orderItem.hj_no" placeholder="填写快递单号"
																size="mini" clearable></el-input>
														</div>
													</div>
													<div style="text-align: right; margin: 0">
														<el-button size="mini" type="text"
															@click="orderItem.hjShow = false">取消</el-button>
														<el-button type="primary" size="mini"
															@click="setOrderItemHj(orderItem)">确定</el-button>
													</div>
												</el-popover>

												<el-popover placement="top" width="200" trigger="manual"
													v-model="orderItem.hjShow" v-else>
													<el-link type="primary" slot="reference"
														@click="orderItem.hjShow = !orderItem.hjShow"><span
															style="font-size:12px;">回寄 <i
																class="el-icon-edit"></i></span></el-link>
													<div class="row-edit-input">
														<div class="quick-form">
															<el-input v-model="orderItem.hj_name" placeholder="填写回寄公司"
																size="mini" clearable></el-input>
														</div>
														<div class="quick-form">
															<el-input v-model="orderItem.hj_no" placeholder="填写回寄单号"
																size="mini" clearable></el-input>
														</div>
													</div>
													<div style="text-align: right; margin: 0">
														<el-button size="mini" type="text"
															@click="orderItem.hjShow = false">取消</el-button>
														<el-button type="primary" size="mini"
															@click="setOrderItemHj(orderItem)">确定</el-button>
													</div>
												</el-popover>
											</span>
										</div>
										<div class="verify-kd" v-else>
											<el-popover placement="top" width="200" trigger="manual"
												v-model="orderItem.kdShow">
												<el-link type="primary" slot="reference"
													@click="orderItem.kdShow = !orderItem.kdShow"><span
														style="font-size:12px;">发货 <i class="el-icon-edit"></i></span>
												</el-link>
												<div class="row-edit-input">
													<div class="quick-form">
														<el-input v-model="orderItem.kd_name" placeholder="填写快递公司"
															size="mini" clearable></el-input>
													</div>
													<div class="quick-form">
														<el-input v-model="orderItem.kd_no" placeholder="填写快递单号"
															size="mini" clearable></el-input>
													</div>
												</div>
												<div style="text-align: right; margin: 0">
													<el-button size="mini" type="text"
														@click="orderItem.kdShow = false">取消</el-button>
													<el-button type="primary" size="mini"
														@click="setOrderItemKd(orderItem)">确定</el-button>
												</div>
											</el-popover>
										</div>
									</div>
									<div class="verify" v-if="!orderItem.is_real && !orderItem.need_visit">
										<el-popover placement="top" width="200" trigger="manual"
											v-model="orderItem.parentShow">
											<el-link type="primary" slot="reference"
												@click="orderItem.parentShow = !orderItem.parentShow"><span
													style="font-size:12px;">{{orderItem.parent_order_no?'归属:'+orderItem.parent_order_no:'设置归属'}}
													<i class="el-icon-edit"></i></span></el-link>
											<div class="row-edit-input">
												<el-input v-model="orderItem.parent_order_no" placeholder="填写订单号"
													size="mini"></el-input>
											</div>
											<div style="text-align: right; margin: 0">
												<el-button size="mini" type="text"
													@click="orderItem.parentShow = false">取消</el-button>
												<el-button type="primary" size="mini"
													@click="setOrderItemParent(orderItem)">确定</el-button>
											</div>
										</el-popover>
									</div>
								</div>
							</div>
						</div>
						<div class="order-item" v-for="extendItem in order.extend_items" :key="extendItem.id">
							<div class="good">
								<div class="good-img">
									<el-image :src="extendItem.good.thumb" fit="fill"></el-image>
								</div>
								<div class="good-info">
									<div class="good-title">
										{{extendItem.good.title}}
									</div>
									<div class="good-price">
										{{extendItem.sale_price}} x {{extendItem.num}}
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="member">
						<div class="member-nickname">
							{{order.member?order.member.nickname:''}}
						</div>
						<div class="member-mobile">
							{{order.mobile}}
						</div>
					</div>
					<div class="order-money">
						<div @click="showRemarks(order.id, order.remark_logs)">
							<div v-if="order.remark_logs.length>0">
								<el-link type="danger" icon="el-icon-s-flag" v-if="order.remark_logs[0].type == 4">
								</el-link>
								<el-link type="primary" icon="el-icon-s-flag" v-if="order.remark_logs[0].type == 3">
								</el-link>
								<el-link type="warning" icon="el-icon-s-flag" v-if="order.remark_logs[0].type == 2">
								</el-link>
								<el-link type="info" icon="el-icon-s-flag" v-if="order.remark_logs[0].type == 1">
								</el-link>
							</div>
							<div v-else>
								<el-link type="info" icon="el-icon-s-flag">备注</el-link>
							</div>
						</div>
						<div class="order-payment">
							<strong style="color: #f90000;">实付金额：￥{{order.payment}}</strong><br>
							<span style="color: #006699;">使用余额：¥{{order.pay_balance}}</span>
						</div>
						<div class="order-payment" v-if="order.refund_payment>0">
							退款金额：￥{{order.refund_payment}}
						</div>
					</div>
					<div class="order-status">
						<tableEditSelect propsName="status" :options="orderStatusList" :info="order" url="orders/quick">
						</tableEditSelect>
					</div>
					<div class="order-operation" style="width:450px">
						<div class="btns">
							<el-button type="primary" size="mini" @click="onEdit(order)">编辑</el-button>
							<el-button v-if="power_change_goods==1" type="success" size="mini" @click="onPrice(order)">
								改价</el-button>
							<el-button type="danger" size="mini" @click="onRefund(order)">退款</el-button>
							<el-upload :action="uploadUrl" :headers="uploadHeaders"
								:data="{type:'market', orderId: order.id}" :show-file-list="false" accept="xls,xlsx"
								v-if="order.platform_id == 15">
								<el-button type="warning" size="mini">导入客户</el-button>
							</el-upload>
							<el-button v-if="is_super==1" type="info" size="mini" @click="onDel(order)">删除</el-button>
						</div>
						<div class="btns" style="text-align: center;margin-left: 0px;margin-top: 10px;">
							<div v-if="order.status_progress && order.status_progress.length>0">
								进度：
								<span :key="item.id" v-for="(item,key) in order.status_progress">
									<el-tag effect="light" :disable-transitions="false">
										<el-tooltip class="item" v-if="item.show_finished==1" effect="dark"
											:content="'已'+item.title+'数：'+item.finished+'，未'+item.title+'数：'+item.not_finished"
											placement="top-start">
											<div>
												<span style=" display: inline-block;  width: 70%;">
													{{item.title}}</span>
												<span
													style="display: inline-grid;width: 50%;text-align: center; margin-left: 3px;height: 20px;line-height: 20px;">
													<label
														style="background-color: #2cb92c;width: 100%;line-height: 10px;color: #fff;margin-top: 2px;padding: 0px;">{{item.finished}}</label>
													<label
														style="background-color: red;display: unset;width: 100%;height: 10px;line-height: 10px;color: #fff;top: 11px;">{{item.not_finished}}</label>
												</span>
											</div>
										</el-tooltip>
										<span style=" display: inline-block;  width: 70%;" v-else> {{item.title}}</span>
									</el-tag>
									<i v-if="key<(order.status_progress.length-1)" class="el-icon-right"></i>
								</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div style="color: #333; font-size: 12px; margin-bottom: 20px;float: right;">订单实付总额：￥
			{{totalData.total_payment}}</div>

		<el-pagination background layout="prev, pager, next, total" :page-count="maxpage" :total="total"
			@current-change="pageChange"></el-pagination>

		<el-dialog title="编辑信息" :visible.sync="infoShow" width="60%" @close="resetInfo" :close-on-click-modal="false">
			<el-form :model="info" ref="info" :rules="rules" label-width="120px" :inline="false" size="small">
				<el-form-item label="平台" prop="platform_id">
					<el-radio-group v-model="info.platform_id" @change="getInfoStores">
						<el-radio v-for="platform in platforms" :key="platform.id" :label="platform.id">
							{{platform.title}}
						</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="店铺" prop="store_id">
					<el-radio-group v-model="info.store_id">
						<el-radio v-for="store in infoStores" :key="store.id" :label="store.id">
							{{store.title}}
						</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="订单号" prop="order_no">
					<el-input v-model="info.order_no"></el-input>
				</el-form-item>
				<el-form-item label="下单时间" prop="created_at">
					<el-input v-model="info.created_at"></el-input>
				</el-form-item>
				<el-form-item label="支付时间" prop="payed_at">
					<el-input v-model="info.payed_at"></el-input>
				</el-form-item>
				<el-form-item label="实付金额" prop="payment">
					<el-input v-model="info.payment"></el-input>
				</el-form-item>

				<el-form-item label="属性" prop="pay_type">
					<el-radio-group v-model="info.status">
						<el-radio :label="0">待付款</el-radio>
						<el-radio :label="1">已付款</el-radio>
						<el-radio :label="2">已发卡</el-radio>
						<el-radio :label="3">已发货</el-radio>
						<el-radio :label="4">交易完成</el-radio>
						<el-radio :label="5">退款中</el-radio>
						<el-radio :label="6">已退款</el-radio>
						<el-radio :label="7">已取消</el-radio>
						<el-radio :label="9">团单</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="归属项目" prop="item_type">
					<el-select v-model="info.item_type" filterable size="mini" clearable placeholder="选择归属项目"
						style="width:100%">
						<el-option :value="0" label="无">无</el-option>
						<el-option :value="1" label="疫苗项目">疫苗项目</el-option>
						<el-option :value="2" label="核酸检测项目">核酸检测项目</el-option>
						<el-option :value="3" label="企业服务号项目">企业服务号项目</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="选择产品" prop="goods" v-if="saveType == 1">
					<el-select v-model="orderGoodIds" ref="orderGoodIds" placeholder="请选择套餐" clearable filterable
						multiple @change="setOrderGoods" :filter-method="filterGoods" style="width: 100%;">
						<el-option v-for="good in curGoods" :key="good.id" :label="good.title" :value="good.id">
						</el-option>
					</el-select>
				</el-form-item>
				<el-divider content-position="center">订单明细</el-divider>
				<el-table :data="orderGoods" border stripe>
					<el-table-column prop="thumb" label="缩略图" width="100">
						<template slot-scope="scope">
							<el-image :src="scope.row.thumb" fit="fill"></el-image>
						</template>
					</el-table-column>
					<el-table-column prop="title" label="套餐名"></el-table-column>
					<el-table-column prop="payment" label="实付单价" width="150">
						<template slot-scope="scope">
							<el-input v-model="scope.row.payment" size="mini" clearable></el-input>
						</template>
					</el-table-column>
					<el-table-column prop="num" label="数量" size="mini" width="150">
						<template slot-scope="scope">
							<el-input v-model="scope.row.num" size="mini"></el-input>
						</template>
					</el-table-column>

					<el-table-column prop="is_gift" label="是否赠品" size="mini" width="150">
						<template slot-scope="scope">
							<el-radio-group v-model="scope.row.is_gift">
								<el-radio :label="0">非赠送</el-radio>
								<el-radio :label="1">赠送</el-radio>
							</el-radio-group>
						</template>
					</el-table-column>
				</el-table>

				<el-divider content-position="center">支付信息</el-divider>
				<el-form-item label="支付方式" prop="pay_type">
					<el-radio-group v-model="info.pay_type">
						<el-radio v-for="item in payTypes" :key="item.name" :label="item.name">
							{{item.title}}
						</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="会员ID" prop="nickname">
					<el-input v-model="info.nickname"></el-input>
				</el-form-item>
				<el-form-item label="联系手机" prop="mobile">
					<el-input v-model="info.mobile"></el-input>
				</el-form-item>
				<el-form-item label="收件人" prop="consignee">
					<el-input v-model="info.consignee"></el-input>
				</el-form-item>
				<el-form-item label="详细地址" prop="address">
					<el-input v-model="info.address"></el-input>
				</el-form-item>
				<el-form-item label="备注" prop="remark">
					<el-input v-model="info.remark"></el-input>
				</el-form-item>
			</el-form>

			<span slot="footer">
				<el-button @click="orderhandleClose">取消</el-button>
				<el-button type="primary" @click="subInfo">提交</el-button>
			</span>
		</el-dialog>

		<el-dialog title="预约信息" :visible.sync="showAppointment" width="40%" @close="resetAppointment"
			:close-on-click-modal="false">
			<el-form :model="infoAppointment" ref="infoAppointment" :rules="appointRules" label-width="120px"
				:inline="false" size="small">
				<el-form-item label="体检人姓名" prop="realname">
					<el-input v-model="infoAppointment.realname"></el-input>
				</el-form-item>
				<el-form-item label="证件号" prop="id_no">
					<el-input v-model="infoAppointment.id_no"></el-input>
				</el-form-item>
				<el-form-item label="联系电话" prop="mobile">
					<el-input v-model="infoAppointment.mobile"></el-input>
				</el-form-item>
				<el-form-item label="性别" prop="sex">
					<el-radio-group v-model="infoAppointment.sex">
						<el-radio :label="1">男</el-radio>
						<el-radio :label="2">女</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="婚否" prop="merry">
					<el-radio-group v-model="infoAppointment.merry">
						<el-radio :label="1">已婚</el-radio>
						<el-radio :label="2">未婚</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="预约门店" prop="org_id">
					<el-select v-model="infoAppointment.org_id" filterable>
						<el-option v-for="shop in shops" :key="shop.id" :label="shop.title" :value="shop.id">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="预约日期" prop="visit_time">
					<el-date-picker v-model="infoAppointment.visit_time" value-format="yyyy-MM-dd" type="date"
						size="mini" placeholder="选择体检日期">
					</el-date-picker>
				</el-form-item>
			</el-form>
			<span slot="footer">
				<el-button @click="showAppointment = false">取消</el-button>
				<el-button type="primary" @click="subAppointment">确定</el-button>
			</span>
		</el-dialog>

		<el-dialog title="开卡" :visible.sync="showOpenCard" width="30%" @close="resetCard" :close-on-click-modal="false">
			<el-form :model="cardForm" ref="cardForm" :rules="cardRules" label-width="80px" :inline="false" size="mini">
				<el-form-item label="结算方式">
					<el-radio-group v-model="cardForm.type">
						<el-radio :label="1">采购卡</el-radio>
						<el-radio :label="2">月结卡</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="结算渠道">
					<el-select v-model="cardForm.channel_id" filterable @change="getCards" style="width: 100%;">
						<el-option v-for="channel in channels" :key="channel.id" :label="channel.title"
							:value="channel.id">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="卡号">
					<el-select v-model="cardForm.card_id" filterable style="width: 100%;">
						<el-option v-for="card in cards" :key="card.id"
							:label="card.code+'['+card.sex_text+(card.city?card.city:'')+']'" :value="card.id">
						</el-option>
					</el-select>
				</el-form-item>
			</el-form>

			<span slot="footer">
				<el-button @click="showOpenCard = false">取消</el-button>
				<el-button type="primary" @click="openCard">确定</el-button>
			</span>
		</el-dialog>

		<el-dialog title="退款" :visible.sync="showRefundStatus" width="50%" @close="resetRefund"
			:close-on-click-modal="false">
			<el-form :model="refundForm" ref="refundForm" :rules="refundRules" label-width="120px" :inline="false"
				size="mini">
				<el-form-item label="退款金额">
					<el-radio-group v-model="refundForm.refund_type">
						<el-radio :label="0">全额退款</el-radio>
						<el-radio :label="1">部分退款</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="退款方式">
					<el-radio-group v-model="refundForm.online_type">
						<el-radio :label="1">线上退款</el-radio>
						<el-radio :label="2">线下退款</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="退款金额">
					<el-input v-model="refundForm.diff_price" clearable></el-input>
				</el-form-item>
				<el-form-item label="退款账号类型">
					<el-radio-group v-model="refundForm.refund_account_type">
						<el-radio label="wxpay" v-if="refundForm.refund_account_type=='wxpay'">微信</el-radio>
						<el-radio label="alipay" v-if="refundForm.refund_account_type!='wxpay'">支付宝</el-radio>
						<el-radio label="credit" v-if="refundForm.refund_account_type!='wxpay'">信用卡</el-radio>
						<el-radio label="huabei" v-if="refundForm.refund_account_type!='wxpay'">花呗</el-radio>
						<el-radio label="goback">原路返回</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="退款账号">
					<el-input v-model="refundForm.refund_account"></el-input>
				</el-form-item>
				<el-form-item label="退款实名认证">
					<el-input v-model="refundForm.real_name"></el-input>
				</el-form-item>
				<el-form-item label="退款原因">
					<el-input v-model="refundForm.reason"></el-input>
				</el-form-item>
			</el-form>
			<el-divider content-position="left">退款记录</el-divider>
			<el-table :data="refundLogs" border stripe>
				<el-table-column label="退款账号类型" prop="refund_account_type"></el-table-column>
				<el-table-column label="金额" prop="diff_price"></el-table-column>
				<el-table-column label="退款原因" prop="remark"></el-table-column>
				<el-table-column label="申请时间" prop="created_at"></el-table-column>
				<el-table-column label="退款状态" prop="status_text"></el-table-column>
				<el-table-column label="登记人" prop="adminer"></el-table-column>
				<el-table-column label="操作">
					<template slot-scope="scope">
						<!-- <el-link :href="scope.row.voucher_img">查看退款凭证</el-link> -->
						<div class="photo1">
							<el-link :src="photo" fit="fill" :lazy="true" v-for="(photo,i) in scope.row.voucher_img"
								:key="i" @click="showPreview(photo)">查看退款凭证{{i+1}}</el-link>
						</div>
					</template>

				</el-table-column>
			</el-table>

			<span slot="footer">
				<el-button @click="showRefundStatus = false">取消</el-button>
				<el-button type="primary" @click="subRefund">确定</el-button>
			</span>
		</el-dialog>

		<el-dialog title="备注记录" :visible.sync="showRemarksStatus" width="40%" @close="resetRemark"
			:close-on-click-modal="false">
			<el-form :model="remarkForm" ref="remarkForm" :rules="remarkRules" label-width="80px" :inline="false"
				size="normal">
				<el-form-item label="标记">
					<el-radio-group v-model="remarkForm.type">
						<el-radio :label="1">
							<el-link type="info" icon="el-icon-s-flag"></el-link>
						</el-radio>
						<el-radio :label="2">
							<el-link type="warning" icon="el-icon-s-flag"></el-link>
						</el-radio>
						<el-radio :label="3">
							<el-link type="primary" icon="el-icon-s-flag"></el-link>
						</el-radio>
						<el-radio :label="4">
							<el-link type="danger" icon="el-icon-s-flag"></el-link>
						</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="备注" prop="remark">
					<el-input v-model="remarkForm.remark" placeholder="请填写备注" size="mini"></el-input>
				</el-form-item>
			</el-form>
			<el-table :data="this.remarks" border stripe>
				<el-table-column label="备注" prop="remark">
					<template slot-scope="scope">
						<el-link type="danger" icon="el-icon-s-flag" v-if="scope.row.type == 4"></el-link>
						<el-link type="primary" icon="el-icon-s-flag" v-if="scope.row.type == 3"></el-link>
						<el-link type="warning" icon="el-icon-s-flag" v-if="scope.row.type == 2"></el-link>
						<el-link type="info" icon="el-icon-s-flag" v-if="scope.row.type == 1"></el-link>
						{{scope.row.remark}}
					</template>
				</el-table-column>
				<el-table-column label="操作人" prop="adminer" width="80"></el-table-column>
				<el-table-column label="时间" prop="created_at"></el-table-column>
			</el-table>

			<span slot="footer">
				<el-button @click="showRemarksStatus = false">关闭</el-button>
				<el-button type="primary" @click="saveRemark">提交</el-button>
			</span>
		</el-dialog>

		<el-dialog title="订单发票" :visible.sync="showBillStatus" width="50%" @close="resetBillForm"
			:close-on-click-modal="false">
			<el-form :model="billForm" ref="billForm" :rules="billRule" label-width="120px" :inline="false" size="mini"
				style="height: 400px;overflow-y: scroll;">
				<el-form-item label="抬头类型">
					<el-radio-group v-model="billForm.company_type">
						<el-radio :label="1">企业</el-radio>
						<el-radio :label="2">个人</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="发票抬头">
					<el-input v-model="billForm.company_name" placeholder="发票抬头" size="mini"></el-input>
				</el-form-item>
				<el-form-item label="公司地址" v-if="billForm.company_type==1">
					<el-input v-model="billForm.company_addr" placeholder="公司地址" size="mini"></el-input>
				</el-form-item>
				<el-form-item label="公司电话" v-if="billForm.company_type==1">
					<el-input v-model="billForm.company_tel" placeholder="公司电话" size="mini"></el-input>
				</el-form-item>
				<el-form-item label="公司开户行" v-if="billForm.company_type==1">
					<el-input v-model="billForm.company_bank" placeholder="公司开户行" size="mini"></el-input>
				</el-form-item>
				<el-form-item label="公司开户账号" v-if="billForm.company_type==1">
					<el-input v-model="billForm.company_account" placeholder="公司开户账号" size="mini"></el-input>
				</el-form-item>
				<el-form-item label="税号" v-if="billForm.company_type==1">
					<el-input v-model="billForm.duty_no" placeholder="税号" size="mini"></el-input>
				</el-form-item>
				<el-form-item label="申请人">
					<el-input v-model="billForm.realname" placeholder="申请人" size="mini"></el-input>
				</el-form-item>
				<el-form-item label="发票内容">
					<el-input v-model="billForm.title" placeholder="发票内容" size="mini"></el-input>
				</el-form-item>
				<el-form-item label="发票金额">
					<el-input v-model="billForm.amount" placeholder="发票金额" size="mini"></el-input>
				</el-form-item>
				<el-form-item label="开票公司">
					<el-input v-model="billForm.company_billing" placeholder="开票公司" size="mini"></el-input>
				</el-form-item>
				<el-form-item label="发票类型">
					<el-radio-group v-model="billForm.type">
						<el-radio :label="1">电子发票</el-radio>
						<el-radio :label="2">纸质发票</el-radio>
						<el-radio :label="3">专用电子发票</el-radio>
						<el-radio :label="4">专用纸质发票</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="备注">
					<el-input v-model="billForm.remark" placeholder="备注" size="mini"></el-input>
				</el-form-item>
				<el-form-item label="联系电话">
					<el-input v-model="billForm.mobile" placeholder="联系电话" size="mini"></el-input>
				</el-form-item>
				<el-form-item label="电子邮箱">
					<el-input v-model="billForm.email" placeholder="电子邮箱" size="mini"></el-input>
				</el-form-item>

				<el-form-item label="收件人" v-if="billForm.type==2||billForm.type==4">
					<el-input v-model="billForm.consignee" placeholder="收件人" size="mini"></el-input>
				</el-form-item>
				<el-form-item label="收件地址" v-if="billForm.type==2||billForm.type==4">
					<el-input v-model="billForm.address" placeholder="收件地址" size="mini"></el-input>
				</el-form-item>
				<el-form-item label="物流公司" v-if="billForm.type==2||billForm.type==4">
					<el-input v-model="billForm.transport" placeholder="物流公司" size="mini"></el-input>
				</el-form-item>
				<el-form-item label="快递单号" v-if="billForm.type==2||billForm.type==4">
					<el-input v-model="billForm.transport_no" placeholder="快递单号" size="mini"></el-input>
				</el-form-item>

				<el-form-item label="开票凭证">
					<div class="photo">
						<el-image :src="photo" fit="fill" :lazy="true" v-for="(photo,i) in billForm.bill_photo" :key="i"
							@click="showPreview(photo)"></el-image>
					</div>
				</el-form-item>
			</el-form>

			<span slot="footer">
				<el-button @click="showBillStatus = false">取消</el-button>
				<el-button type="primary" @click="onBill" v-if="!billForm.status || billForm.status == 0">提交</el-button>
			</span>
		</el-dialog>
		<el-dialog :visible.sync="photoShow">
			<img width="100%" :src="photoUrl" alt="">
		</el-dialog>

		<el-dialog title="修改套餐" :visible.sync="showItemEdit" :before-close="handleClose" :close-on-click-modal="false">
			<el-form :model="itemEditform" :rules="itemEditRules">
				<el-form-item label="搜索更改套餐" label-width="120px">
					<el-input v-model="itemEditform.good_title" autocomplete="off" style="width: 300px;"></el-input>
					<el-button type="success" effect="dark" @click="itemEditSerchFunc" style="margin-left:10px">搜索
					</el-button>
				</el-form-item>
				<el-form-item label="选择套餐" label-width="120px" prop="good_id">
					<el-select v-model="itemEditform.good_id" value-key="" filterable placeholder="选择套餐"
						style="width: 300px;">
						<el-option v-for="good in itemEditSearchGoods" :key="good.id" :label="good.title"
							:value="good.id">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="套餐是否赠送">
					<el-radio-group v-model="itemEditform.is_gift">
						<el-radio :label="0">非赠送</el-radio>
						<el-radio :label="1">赠送</el-radio>
					</el-radio-group>
				</el-form-item>

				<el-form-item v-if="itemEditform.verify_code_id<=0" label="数量" label-width="120px" prop="num">
					<el-input v-model.number="itemEditform.num" style="width: 300px;"></el-input>
				</el-form-item>
				<el-form-item label="单个套餐实付价" label-width="120px" prop="new_payment">
					<el-input v-model="itemEditform.new_payment" style="width: 300px;"></el-input>
				</el-form-item>
				<span>（订单实付金额：￥{{itemEditform.order_payment}}）</span>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="itemEditCancel()">取 消</el-button>
				<el-button type="primary" @click="itemEditSubmitFunc">确 定</el-button>
			</div>
		</el-dialog>

		<el-dialog title="修改订单总价" :visible.sync="showOrderPaymentEdit" :before-close="orderPaymentEditCancel"
			:close-on-click-modal="false">
			<el-form :model="orderPaymentEditform">
				<el-form-item label="总实付价" label-width="200px" prop="order_payment">
					<el-input v-model="orderPaymentEditform.order_payment" style="width: 300px;"></el-input>
				</el-form-item>
				<el-form-item label="是否平分更新到订单明细" label-width="200px">
					<el-radio-group v-model="orderPaymentEditform.update_item_payment">
						<el-radio :label="0">不更新</el-radio>
						<el-radio :label="1">更新</el-radio>
					</el-radio-group>
				</el-form-item>

			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="orderPaymentEditCancel()">取 消</el-button>
				<el-button type="primary" @click="orderPaymentEditSubmitFunc">确 定</el-button>
			</div>
		</el-dialog>

		<el-dialog title="查看更多核销码" :visible.sync="showMoreCode" :before-close="showMoreCodeClose"
			:close-on-click-modal="false">
			<div v-loading="moreCodeLoad">
				<div class="batchs" v-if="batchPermission">
					<el-select v-model="batchChannelId" placeholder="请选择渠道" filterable size="mini">
						<el-option v-for="channel in channels" :key="channel.id" :label="channel.title"
							:value="channel.id"></el-option>
					</el-select>

					<el-popconfirm placement="right" confirm-button-text='开卡' cancel-button-text='取消'
						icon="el-icon-info" icon-color="red" title="请先确认库存中有足够的卡，确定要批量开卡吗？" @confirm="batchOpenCard">
						<el-button slot="reference" type="primary" size="mini">批量开卡</el-button>
					</el-popconfirm>

					<el-popconfirm placement="right" confirm-button-text='回收' cancel-button-text='取消'
						icon="el-icon-info" icon-color="red" title="确定要批量回收吗？" @confirm="batchRecoveryCard">
						<el-button slot="reference" type="danger" size="mini">批量回收</el-button>
					</el-popconfirm>
				</div>

				<div class="verify" v-for="verify in moreVerifyCodes" :key="verify.id">
					<div class="verify-header">
						<div>
							<tableEditInput propsName="code" :info="verify" url="order/verify_codes/quick">
							</tableEditInput>
							<el-popconfirm v-if="verify.code && verify.status==0" placement="top"
								confirm-button-text='核销' cancel-button-text='取消' title="确定已核销吗？"
								@confirm="writeOff(verify.id)">
								<el-button type="success" effect="dark" size="mini" slot="reference"
									style="padding: 5px;">核销</el-button>
							</el-popconfirm>
							<span v-if="verify.status==1">核销时间：{{verify.verify_at}}</span>
							<el-button v-if="power_change_goods==1" effect="dark" size="mini" slot="reference"
								type="warning" style="padding: 5px;"
								@click="showItemEditFunc(verify.order_item,verify.order_item.payment,verify.id)">改套餐
							</el-button>

							<div v-for="item in verify.children" :key="item.id">
								<div class="good">
									<div class="good-img">
										<el-image :src="item.order_item.thumb" fit="fill"></el-image>
									</div>
									<div class="good-info">
										<div class="good-title">{{item.order_no}}
											<el-tag v-if="item.store" effect="dark" :color="item.store.platform.color"
												size="mini" style="padding:2;font-size:12px">{{item.store.title}}
											</el-tag>
										</div>
										<div class="good-title">{{item.code}}</div>
										<div class="good-title">
											{{item.order_item.title}}
										</div>
										<div class="good-price">
											{{item.order_item.payment}}
										</div>
									</div>
								</div>
							</div>
						</div>
						<span v-if="verify.modifications.length>0">核销人: {{verify.modifications[0].adminer}}</span>
						<span>
							<orderBind :info="verify" @subQuick="getTableData"></orderBind>
							<div v-if="verify.parent">
								<div>{{verify.parent.order_no}}
									<el-tag v-if="verify.parent.store" effect="dark"
										:color="verify.parent.store.platform.color" size="mini"
										style="padding:2;font-size:12px">{{verify.parent.store.title}}</el-tag>
								</div>
								<div v-for="appointment in verify.parent.appointments" :key="appointment.id">
									{{appointment.realname}} {{appointment.visit_time}} {{appointment.status_text}}
								</div>
							</div>
						</span>
					</div>
					<div class="verify-body" v-if="!verify.parent && verify.code">
						<div>
							<el-link v-if="verify.appointments.length == 0" type="primary" icon="el-icon-date"
								@click="setAppointment(verify, 0)">预约</el-link>
							<span class="appointment-info" v-else>
								<i class="el-icon-user"></i> {{verify.appointments[0].realname}}
								<i class="el-icon-date"></i> {{verify.appointments[0].visit_time}}
								<label v-if="verify.appointments[0].shop && verify.appointments[0].shop.area"> <i
										class="el-icon-place"></i> {{verify.appointments[0].shop.area.name}} </label>
								<el-tag type="danger" size="mini" effect="dark" v-if="verify.appointments[0].sex == 2">
									<i class="el-icon-female"></i> 女</el-tag>
								<el-tag type="success" size="mini" effect="dark" v-else><i class="el-icon-male"></i> 男
								</el-tag>
								<el-tag color="#DAD787" size="mini" effect="dark"
									v-if="verify.appointments[0].merry == 2"><i class="el-icon-user"></i> 未婚</el-tag>
								<el-tag color="#E59191" size="mini" effect="dark" v-else><i class="el-icon-user"></i> 已婚
								</el-tag>
							</span>
							<el-divider direction="vertical"></el-divider>
							<span v-if="verify.card">
								<i class="el-icon-bank-card"></i> {{verify.card.code}} / <i class="el-icon-key"></i>
								{{verify.card.passwd}} [{{verify.card.channel?verify.card.channel.title:''}} /
								{{verify.card.sex_text}} / {{verify.card.city?verify.card.city:''}}]
							</span>
							<el-link type="primary" icon="el-icon-bank-card" v-else
								@click="openCardShow(verify.id, verify.order_item.good_id)">开卡</el-link>
							<div style="display: inline-block;">
								<el-tag size="mini"
									v-if="verify.appointments.length > 0 && (verify.appointments[0].status ==3 || verify.appointments[0].status ==4)">
									已体检</el-tag>
								<el-popconfirm
									v-if="verify.card && (verify.appointments.length == 0 || (verify.appointments[0].status !=3 && verify.appointments[0].status !=4))"
									placement="top" confirm-button-text='回收' cancel-button-text='取消' icon-color="red"
									title="确定回收吗？" @confirm="onRecovery(verify.id, verify.card.id)" class="btn-pop">
									<el-button type="danger" effect="dark" size="mini" slot="reference">回收</el-button>
								</el-popconfirm>
							</div>
						</div>
						<el-button-group v-if="verify.order_item.is_multiple && verify.appointments.length > 0">
							<el-button size="mini" type="info" @click="changeVisitDate(item.id)"
								v-for="item in verify.appointments" :key="item.id">{{item.visit_time}}</el-button>
						</el-button-group>
					</div>
				</div>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="showMoreCodeClose">取 消</el-button>
			</div>
		</el-dialog>

	</div>
</template>

<script>
	import tableEditInput from '@/components/TableEditInput'
	import tableEditSelect from '@/components/TableEditSelect'
	import orderBind from '@/components/OrderBind'
	export default {
		components: {
			tableEditInput,
			orderBind,
			tableEditSelect,
		},
		data() {
			var checkNum = (rule, value, callback) => {
				console.log('checknum', value);
				if (value === '') {
					return callback(new Error('数量不能为空'));
				} else if (value <= 0) {
					return callback(new Error('数量低于或等于0，将删除该套餐信息，请慎重操作'));
				}
				// setTimeout(() => {
				//     if (!Number.isInteger(value)) {
				//         callback(new Error('请输入数字值'));
				//     } else {
				//         if (value < 1) {
				//         callback(new Error('必须大于等于1'));
				//         } else {
				//         callback();
				//         }
				//     }
				// }, 1000);
			};
			return {
				is_super: 0,
				power_change_goods: 0,
				itemEditSearchGoods: [],
				itemEditform: {
					verify_code_id: 0,
					order_item_id: 0,
					order_id: 0,
					order_payment: 0,
					good_title: '',
					good_id: 0,
					num: 1,
					new_payment: 0,
					is_gift: 0
				},
				orderPaymentEditform: {
					order_id: 0,
					order_payment: 0,
					update_item_payment: 0
				},
				loading: false,
				actTableType: '-1',
				filter: {
					keyword: '',
					status: []
				},
				tableData: [],
				page: 1,
				maxpage: 1,
				total: 0,
				infoShow: false,
				saveType: 1, // 1新增 2编辑
				info: {
					platform_id: '',
					store_id: '',
					order_no: '',
					created_at: '',
					payed_at: '',
					pay_no: '',
					payment: '',
					status: 1,
					goods: [],
					pay_type: 'alipay',
					nickname: '',
					city: '',
					mobile: '',
					address: '',
					consignee: '',
					item_type: 0
				},
				rules: {
					platform_id: [{
						required: true,
						message: '请选择平台',
						trigger: 'change'
					}],
					store_id: [{
						required: true,
						message: '请选择店铺',
						trigger: 'change'
					}],
					order_no: [{
						required: true,
						message: '请填写订单号',
						trigger: 'blur'
					}],
					payment: [{
						required: true,
						message: '请填写实付金额',
						trigger: 'blur'
					}],
					created_at: [{
						required: true,
						message: '请填写下单时间',
						trigger: 'blur'
					}],
					payed_at: [{
						required: true,
						message: '请填写支付时间',
						trigger: 'blur'
					}],
					nickname: [{
						required: true,
						message: '请填写下单人',
						trigger: 'blur'
					}],
					mobile: [{
						required: true,
						message: '请填写下单人手机',
						trigger: 'blur'
					}],

				},
				itemEditRules: {
					num: [{
						validator: checkNum,
						trigger: 'blur'
					}]
				},
				platforms: [],
				currentPlatformId: 0,
				stores: [],
				infoStores: [],
				payTypes: [],
				allGoods: [],
				curGoods: [],
				orderGoodIds: [],
				orderGoods: [],
				orderStatusList: [{
						id: 0,
						title: '待付款'
					},
					{
						id: 1,
						title: '已付款'
					},
					{
						id: 2,
						title: '已开卡'
					},
					{
						id: 3,
						title: '已发货'
					},
					{
						id: 4,
						title: '已完成'
					},
					{
						id: 5,
						title: '退款中'
					},
					{
						id: 6,
						title: '已退款'
					},
					{
						id: 7,
						title: '已取消'
					},
					{
						id: 9,
						title: '团单'
					},
				],
				kefus: [],
				showAppointment: false,
				currentVerify: null,
				infoAppointment: {
					org_id: '',
					sex: 1,
					merry: 1
				},
				appointRules: {
					realname: [{
						required: true,
						message: '请填写体检人',
						trigger: 'blur'
					}],
					mobile: [{
						required: true,
						message: '请填写体检人联系电话',
						trigger: 'blur'
					}],
					id_no: [{
						required: true,
						message: '请填写体检身份证',
						trigger: 'blur'
					}],
					visit_time: [{
						required: true,
						message: '请选择体检日期',
						trigger: 'blur'
					}],
					org_id: [{
						required: true,
						message: '请选择体检分院',
						trigger: 'change'
					}],
				},
				shops: [],
				cardForm: {
					type: 1,
					channel_id: '',
					card_id: ''
				},
				showOpenCard: false,
				channels: [],
				cards: [],
				cardRules: {
					card_id: [{
						required: true,
						message: '请选择体检卡',
						trigger: 'change'
					}],
				},
				parentVerifyCodes: [],
				showRefundStatus: false,
				refundForm: {
					refund_account_type: 'alipay',
					refund_type: 0,
					online_type: 1,
					diff_price: '',
				},
				refundRules: {
					diff_price: [{
						required: true,
						message: '请填写退款金额',
						trigger: 'blur'
					}],
					reason: [{
						required: true,
						message: '请填写退款原因',
						trigger: 'blur'
					}],
				},
				refundLogs: [],
				totalData: {},
				showRemarksStatus: false,
				remarks: [],
				remarkForm: {
					type: 1,
					remark: ''
				},
				remarkRules: {
					remark: [{
						required: true,
						message: '请填写备注内容',
						trigger: 'blur'
					}],
				},
				billOrders: [],
				showBillStatus: false,
				billForm: {
					company_type: 1,
					type: 1,
					title: '体检费'
				},
				billRule: {

				},
				photoUrl: '',
				photoShow: false,
				showItemEdit: false,
				showOrderPaymentEdit: false,
				filterAllGoods: [],
				showMoreCode: false,
				moreVerifyCodes: [],
				moreCodeLoad: false,
				uploadHeaders: {
					Authorization: 'Bearer ' + sessionStorage.getItem('token')
				},
				uploadUrl: this.$util.host + '/api/orders/uploadCustomersFile',
				batchOpenCardOrderId: '',
				batchChannelId: '',
				batchPermission: false,
			}
		},
		mounted() {
			let query = this.$route.query
			if (query.keyword) {
				this.filter.keyword = query.keyword
			}
			this.getTableData()
			this.getPlatforms()
			this.getStores()
			this.getPayTypes()
			this.getGoods()
		},
		methods: {
			getTableData() {
				this.tableData = []
				this.loading = true
				let data = this.filter
				data.page = this.page
				this.$util.get('orders', data).then(res => {
					this.tableData = res.data
					this.loading = false
					this.maxpage = res.last_page
					this.totalData = res.total_data
					this.total = res.total
					this.power_change_goods = res.power_change_goods
					this.is_super = res.is_super
				})
				this.showMoreCodeClose()
			},
			changeTab(tab) {
				this.tableData = []
				this.page = 1
				this.maxpage = 1
				this.total = 0
				this.totalData = {}
				if (tab.name >= 0) {
					this.filter.status = [tab.name]
				} else {
					delete this.filter.status
				}
				this.getTableData()
			},
			getPlatforms() {
				this.$util.get('slc', {
					model: 'Platform'
				}).then(res => {
					this.platforms = res
				})
			},
			getStores() {
				this.$util.get('slc', {
					model: 'Store'
				}).then(res => {
					this.stores = res
				})
			},
			getPayTypes() {
				this.$util.get('slc', {
					model: 'PayType'
				}).then(res => {
					this.payTypes = res
				})
			},
			getGoods() {
				this.$util.get('slc', {
					model: 'Good'
				}).then(res => {
					this.allGoods = res
				})
			},
			onSearch() {
				this.tableData = []
				this.page = 1
				this.maxpage = 1
				this.total = 0
				this.getTableData()
			},
			onRefresh() {
				this.actTableType = '-1'
				this.filter = {
					keyword: '',
					status: []
				}
				this.tableData = []
				this.page = 1
				this.maxpage = 1
				this.total = 0
				this.getTableData()
			},
			getInfoStores() {
				this.currentPlatformId = this.info.platform_id
				if (this.info.platform_id == 11 || this.info.platform_id == 16) {
					this.info.pay_type = 'alipay'
				} else {
					this.info.pay_type = 'wxpay'
				}
				if (this.info.platform_id == 15) {
					//线下
					this.info.order_no = this.$moment(new Date()).format('YYYYMMDDHHmmss') + Math.ceil(Math.random() *
						10000)
					this.info.created_at = this.$moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
					this.info.payed_at = this.$moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
				}
				this.getChildStores(this.info.platform_id)
			},
			getChildStores(platform_id) {
				this.$util.get('slc', {
					model: 'Store',
					pid: platform_id
				}).then(res => {
					this.infoStores = res
				})
			},
			getFilterStores() {
				this.currentPlatformId = this.filter.platform_id
				this.getStores()
			},
			pageChange(page) {
				this.tableData = []
				this.page = page
				this.getTableData()
			},
			onCreate() {
				this.saveType = 1
				this.infoShow = true
				this.rules.goods = [{
					required: true,
					message: '请选择产品',
					trigger: 'blur'
				}]
			},
			onEdit(row) {
				this.saveType = 2
				this.info = {
					id: row.id,
					platform_id: row.platform_id,
					store_id: row.store_id,
					order_no: row.order_no,
					created_at: row.created_at,
					payed_at: row.payed_at,
					pay_no: row.pay_no,
					payment: row.payment,
					status: row.status,
					pay_type: row.pay_type,
					nickname: row.member ? row.member.nickname : '',
					mobile: row.mobile,
					address: row.address,
					consignee: row.consignee,
					item_type: row.item_type
				}
				delete this.rules.goods

				this.$util.get('slc', {
					model: 'Store',
					pid: row.platform_id
				}).then(res => {
					this.infoStores = res
					this.info.store_id = row.store_id
				})

				row.order_items.forEach(item => {
					let orderGood = {}
					orderGood.good_id = item.good_id
					orderGood.title = item.title
					orderGood.thumb = item.thumb
					orderGood.num = 1
					orderGood.sale_price = item.sale_price
					orderGood.payment = item.payment
					orderGood.is_gift = item.is_gift ? item.is_gift : 0
					this.orderGoods.push(orderGood)
				})
				this.infoShow = true
			},
			onDel(row) {
				console.log(row.id)
				this.$confirm('删除后相关数据也将会一起被删除，确定删除吗？').then(() => {
					this.$util.del('orders/' + row.id).then((res) => {
						if (res.code != 0) {
							this.$message(res.msg ? res.msg : '操作失败');
						} else {
							this.getTableData()
						}

					})
				}).catch(() => {});

			},
			onQuick(id, field, val) {
				this.$util.put('orders/quick/' + id, {
					field: field,
					value: val
				}).then(() => {
					this.getTableData()
				})
			},
			subInfo() {

				this.$refs['info'].validate((valid) => {
					if (valid) {
						this.$confirm('确定提交保存订单信息吗？')
							.then(() => {
								if (this.saveType == 1) {
									this.$util.post('orders', this.info).then((res) => {
										if (res.code != 0) {
											this.$message(res.msg ? res.msg : '操作失败')
										} else {
											this.getTableData()
											this.infoShow = false
										}

									})
								} else {
									this.$util.put('orders/' + this.info.id, this.info).then((res) => {
										if (res.code != 0) {
											this.$message(res.msg ? res.msg : '操作失败')
										} else {
											this.getTableData()
											this.infoShow = false
										}

									})
								}

							})
							.catch(() => {});

					} else {
						return false;
					}
				})

			},
			onBill() {
				if (this.billForm.id) {
					this.$util.put('finances/order/bill/' + this.billForm.id, this.billForm).then(res => {
						delete this.billForm.orderIds
						if (res.code > 0) {
							this.$message(res.msg)
						} else {
							this.billOrders = []
							this.$message('提交成功')
						}
						this.billOrders = []
					})
				} else {
					this.$util.post('finances/order/bill', this.billForm).then(res => {
						if (res.code > 0) {
							this.$message(res.msg)
						} else {
							this.billOrders = []
							this.$message('提交成功')
							this.getTableData()
							this.showBillStatus = false
						}
					})
				}
			},
			resetInfo() {
				this.info = {
					platform_id: '',
					store_id: '',
					order_no: '',
					created_at: '',
					payed_at: '',
					pay_no: '',
					payment: '',
					status: 1,
					goods: '',
					pay_type: 'alipay',
					nickname: '',
					city: '',
					mobile: '',
					address: '',
					consignee: '',
					item_type: 0
				}
				this.orderGoodIds = []
				this.orderGoods = []
				this.infoStores = []
				this.filterAllGoods = []
				this.curGoods = []
				this.rules = {
					platform_id: [{
						required: true,
						message: '请选择平台',
						trigger: 'change'
					}],
					store_id: [{
						required: true,
						message: '请选择店铺',
						trigger: 'change'
					}],
					order_no: [{
						required: true,
						message: '请填写订单号',
						trigger: 'blur'
					}],
					payment: [{
						required: true,
						message: '请填写实付金额',
						trigger: 'blur'
					}],
					created_at: [{
						required: true,
						message: '请填写下单时间',
						trigger: 'blur'
					}],
					payed_at: [{
						required: true,
						message: '请填写支付时间',
						trigger: 'blur'
					}],
					nickname: [{
						required: true,
						message: '请填写下单人',
						trigger: 'blur'
					}],
					mobile: [{
						required: true,
						message: '请填写下单人手机',
						trigger: 'blur'
					}],
				}
			},
			onSend() {

			},
			onPrice(order) {
				this.orderPaymentEditform.order_id = order.id
				this.orderPaymentEditform.order_payment = order.payment
				this.orderPaymentEditform.update_item_payment = 0
				this.showOrderPaymentEdit = true
			},
			onRefund(row) {
				this.refundForm.order_id = row.id
				this.refundForm.diff_price = row.payment
				this.refundForm.platform = row.platform_id
				this.refundForm.store = row.store_id
				this.refundForm.order_no = row.order_no
				this.refundForm.refund_account_type = row.pay_type
				this.refundLogs = row.refund_difference_logs
				this.showRefundStatus = true
			},
			setOrderGoods() {
				this.orderGoods = []
				for (let i = 0; i < this.orderGoodIds.length; i++) {
					const id = this.orderGoodIds[i];
					//console.log('id',id,this.filterAllGoods);
					for (var g = 0; g < this.filterAllGoods.length; g++) {
						let good = this.filterAllGoods[g]
						if (good.id == id) {
							let orderGood = {}
							orderGood.good_id = good.id
							orderGood.title = good.title
							orderGood.thumb = good.thumb
							orderGood.num = 1
							orderGood.sale_price = good.sale_price
							orderGood.is_gift = 0
							this.orderGoods.push(orderGood)
							break;
						}
					}

				}
				this.info.goods = this.orderGoods
				this.$nextTick(() => {
					this.$refs.orderGoodIds.blur()
				})
			},
			filterGoods(query) {
				this.curGoods = []
				this.allGoods.forEach(good => {
					if (good.title.includes(query)) {
						this.curGoods.push({
							id: good.id,
							title: good.title,
							thumb: good.thumb,
							sale_price: good.sale_price
						})
						this.filterAllGoods.push({
							id: good.id,
							title: good.title,
							thumb: good.thumb,
							sale_price: good.sale_price
						})
					}
				})
			},
			setVerifyCode(id, field, val) {
				this.$util.put('order/verify_codes/quick/' + id, {
					field: field,
					value: val
				}).then(() => {
					this.getTableData()
				})
			},
			setOrderAdminer(id) {
				this.$util.put('orders/quick/' + id, {
					field: 'adminer',
					value: ''
				}).then((res) => {
					if (res.code != 0) {
						this.$message(res.msg ? res.msg : '操作失败')
					} else {
						this.getTableData()
					}
				})
			},
			setOrderItemKd(row) {
				let data = {
					kd_name: row.kd_name,
					kd_no: row.kd_no
				}
				row.kdShow = false
				this.$util.put('order/order_items/' + row.id, data).then(() => {
					this.getTableData()
				})
			},
			setOrderItemHj(row) {
				let data = {
					hj_name: row.hj_name,
					hj_no: row.hj_no
				}
				row.hjShow = false
				this.$util.put('order/order_items/' + row.id, data).then(() => {
					this.getTableData()
				})
			},
			setAppointment(verify, appointment) {
				this.currentVerify = verify
				//console.log('verify',verify);
				this.showAppointment = true
				if (appointment) {
					this.infoAppointment = appointment
				}
				let itemId = verify && verify.order_item_id ? verify.order_item_id : 0
				this.getShops(itemId)
			},
			resetAppointment() {
				this.infoAppointment = {
					org_id: '',
					sex: 1,
					merry: 1
				}
			},
			subAppointment() {
				this.$refs['infoAppointment'].validate((valid) => {
					if (valid) {
						this.infoAppointment.verify_code_id = this.currentVerify.id
						if (this.currentVerify.appointments.length > 0) {
							this.$util.put('order/appointment/' + this.currentVerify.appointments[0].id, this
								.infoAppointment).then(() => {
								this.getTableData()
								this.showAppointment = false
							})
						} else {
							this.$util.post('order/appointment', this.infoAppointment).then(() => {
								this.getTableData()
								this.showAppointment = false
							})
						}
					} else {
						return false;
					}
				})
			},
			setOrderItemParent(row) {
				row.parentShow = false
				this.$util.put('order/order_items/quick/' + row.id, {
					field: 'parent_order_no',
					value: row.parent_order_no
				}).then(() => {
					this.getTableData()
				})
			},
			getShops(itemId) {
				this.$util.get('slc', {
					model: 'Shop',
					item_id: itemId
				}).then(res => {
					this.shops = res
				})
			},
			openCardShow(vid, gid) {
				this.showOpenCard = true
				this.cardForm.verify_id = vid
				this.cardForm.good_id = gid
				this.getChannels()
			},
			openCard() {
				this.$refs['cardForm'].validate((valid) => {
					if (valid) {
						this.$util.put('order/verify_codes/quick/' + this.cardForm.verify_id, {
							field: 'card_id',
							value: this.cardForm.card_id
						}).then((res) => {
							if (res.code != 0) {
								this.$message(res.msg ? res.msg : '操作失败')
							} else {
								this.showOpenCard = false
								this.getTableData()
							}

						})
					} else {
						return false;
					}
				})
			},
			getCards() {
				this.$util.get('slc', {
					model: 'Card',
					good_id: this.cardForm.good_id,
					channel_id: this.cardForm.channel_id
				}).then(res => {
					this.cards = res
				})
			},
			getChannels() {
				this.$util.get('slc', {
					model: 'Channel'
				}).then(res => {
					this.channels = res
				})
			},
			resetCard() {
				this.cardForm = {
					type: 1,
					channel_id: '',
					card_id: ''
				}
			},
			resetRefund() {
				this.refundForm = {
					refund_account_type: 'alipay',
					refund_type: 0,
					online_type: 1,
					diff_price: '',
				}
			},
			subRefund() {
				this.$util.post('finances/order/refund_difference', this.refundForm).then((res) => {
					if (res.code != 0) {
						this.$message(res.msg ? res.msg : '操作失败')
					} else {
						this.showRefundStatus = false
					}

				})
			},
			onRecovery(vid, cid) {
				this.$util.put('good/cards/quick/' + cid, {
					field: 'status',
					value: 0
				}).then(() => {
					this.showRefundStatus = false
				})
				this.getTableData()
			},
			showRemarks(id, remarks) {
				this.showRemarksStatus = true
				this.remarks = remarks
				this.remarkForm.order_id = id
			},
			resetRemark() {
				this.remarkForm = {
					type: 1,
					remark: ''
				}
			},
			saveRemark() {
				this.$refs['remarkForm'].validate((valid) => {
					if (valid) {
						this.$util.post('order/orderRemarkLogs', this.remarkForm).then(() => {
							this.getTableData()
							this.showRemarksStatus = false
						})
					} else {
						return false;
					}
				})
			},
			showBill() {
				if (this.billOrders.length > 0) {
					let amount = 0
					let ids = []
					this.billOrders.forEach(order => {
						amount = amount + parseFloat(order.payment)
						ids.push(order.id)
					});
					this.billForm.amount = amount
					this.billForm.orderIds = ids
					this.showBillStatus = true
				} else {
					this.$message({
						showClose: true,
						message: '请选择开票订单',
						type: 'danger'
					});
				}
			},
			showOrderBill(bill) {
				this.billForm = bill
				this.showBillStatus = true
			},
			resetBillForm() {
				this.billForm = {
					company_type: 1,
					type: 1,
					title: '体检费'
				}
			},
			showPreview(url) {
				this.photoUrl = url;
				this.photoShow = true;
			},
			writeOff(id) {
				// console.log(id)
				this.$util.put('order/verify_codes/quick/' + id, {
					field: 'status',
					value: 1
				}).then(() => {
					this.getTableData()
				})
			},
			showItemEditFunc(item, orderPayment, vcodeId = 0) {
				//console.log('item',item);
				this.itemEditform.verify_code_id = vcodeId
				this.itemEditform.order_item_id = item.id
				this.itemEditform.order_id = item.order_id
				this.itemEditform.order_payment = orderPayment
				this.itemEditform.num = item.num
				this.itemEditform.good_id = item.good_id
				this.itemEditSearchGoods.push(item.good)
				this.itemEditform.new_payment = item.payment
				this.itemEditform.is_gift = item.is_gift

				this.showItemEdit = true
			},
			itemEditSerchFunc() {
				if (!this.itemEditform.good_title) {
					this.$message('请输入修改套餐名搜索');
				}
				this.$util.get('good/search_goods', {
					title: this.itemEditform.good_title
				}).then((res) => {
					console.log('search', res);
					this.itemEditSearchGoods = res
				})
			},
			itemEditCancel() {
				this.showItemEdit = false;
				this.itemEditSearchGoods = [];
				this.itemEditform = {
					verify_code_id: 0,
					order_item_id: 0,
					order_id: 0,
					order_payment: 0,
					good_title: '',
					good_id: 0,
					num: 1,
					new_payment: 0,
					is_gift: 0
				}
			},
			itemEditSubmitFunc() {
				console.log(this.itemEditform);
				//let param=this.itemEditform
				//console.log(param);
				//let newPayment=param.num * param.new_payment
				let dialogTip = '';
				if (this.itemEditform.num <= 0) {
					dialogTip = '更改数量为0，将删除该套餐明细，是否确定继续？'
				} else {
					dialogTip = '确定更改信息？'
				}
				this.$confirm(dialogTip).then(
					() => {
						this.$util.post('order/order_items/change_good', this.itemEditform).then((res) => {
							console.log(res)
							if (res.code == 400001) {
								this.$message(res.msg);
							} else {
								this.itemEditCancel();
								this.getTableData()
							}

						})
					}
				).catch(() => {});

			},
			handleClose(done) {
				this.$confirm('确认关闭？')
					.then(() => {
						this.itemEditCancel();
						done();
					})
					.catch(() => {});
			},
			orderhandleClose(done) {
				this.$confirm('确定取消编辑订单？')
					.then(() => {
						this.resetInfo()
						this.infoShow = false
						done()
					})
					.catch(() => {});
			},
			orderPaymentEditCancel() {
				this.orderPaymentEditform.order_id = 0
				this.orderPaymentEditform.order_payment = 0
				this.orderPaymentEditform.update_item_payment = 0
				this.showOrderPaymentEdit = false
			},
			orderPaymentEditSubmitFunc() {
				console.log('orderPayment', this.orderPaymentEditform);
				this.$util.post('orders/update_payment', this.orderPaymentEditform).then((res) => {
					console.log(res)
					if (res.code == 400001) {
						this.$message(res.msg);
					} else {
						this.orderPaymentEditCancel();
						this.getTableData()
					}

				})
			},
			getMoreCode(order_id, item_id, platform_id) {
				console.log(order_id, item_id)
				this.showMoreCode = true
				this.batchOpenCardOrderId = order_id
				this.batchPermission = platform_id == 15 ? true : false
				this.moreVerifyCodes = []
				this.moreCodeLoad = true
				this.$util.get('order/verify_codes/get_more_codes', {
					order_id: order_id,
					item_id: item_id
				}).then(res => {
					this.moreCodeLoad = false
					this.moreVerifyCodes = res
					this.getChannels()
				})

			},
			showMoreCodeClose() {
				this.showMoreCode = false
				this.moreVerifyCodes = []
				this.moreCodeLoad = false
			},
			batchOpenCard() {
				if (!this.batchChannelId) {
					this.$message('请选择开卡渠道');
					return
				}
				this.$util.get('orders/batchOpenCard', {
					orderId: this.batchOpenCardOrderId,
					channelId: this.batchChannelId
				}).then(() => {
					this.getTableData()
				})
			},
			batchRecoveryCard() {
				this.$util.get('orders/batchRecoveryCard', {
					orderId: this.batchOpenCardOrderId,
					channelId: this.batchChannelId
				}).then(() => {
					this.getTableData()
				})
			},
			do_export() {
				let data = this.filter
				let url = this.$util.host + '/api/order/export_all';
				//console.log(url);
				let param = '';
				for (let i in data) {
					param += "&" + i + "=" + data[i]
				}
				param = param.trimLeft('&');
				url += '?' + param;
				this.$confirm('若导出失败，请先选择查询条件后再导出').then(() => {
					// window.location.href=url;
					window.open(url);
				});

			},

		},
		watch: {
			'$route'(to) {
				if (to.query.keyword && to.name == 'order_all') {
					this.filter.keyword = to.query.keyword
					this.getTableData()
				}
			}
		}
	}
</script>

<style scoped>
	.btn-pop {
		margin-left: 10px;
	}

	.order {
		color: #333;
		font-size: 12px;
		margin-bottom: 20px;
		border: #eee 1px solid;
	}

	.order-no {
		width: 380px;
	}

	.order-no span {
		margin-right: 10px;
	}

	.order-create {
		width: 200px;
	}

	.pay-time {
		width: 300px;
	}

	.order-header {
		background-color: #f8f8f8;
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 10px;
	}

	.order-body {
		display: flex;
		justify-content: space-between;
		align-items: stretch;
	}

	.order-operation {
		width: 260px;
		text-align: center;
		display: flex;
		flex-direction: column;
		justify-content: center;
	}

	.order-items {
		flex-grow: 1;
		border-right: #eee 1px solid;
		display: flex;
		flex-direction: column;
		justify-content: center;
	}

	.member {
		width: 120px;
		padding: 10px;
		border-right: #eee 1px solid;
		display: flex;
		flex-direction: column;
		justify-content: center;
		text-align: center;
	}

	.order-money {
		width: 120px;
		padding: 10px;
		border-right: #eee 1px solid;
		display: flex;
		flex-direction: column;
		justify-content: center;
	}

	.order-time {
		width: 200px;
		padding: 10px;
		border-right: #eee 1px solid;
		display: flex;
		flex-direction: column;
		justify-content: center;
	}

	.order-status {
		width: 60px;
		padding: 10px;
		border-right: #eee 1px solid;
		display: flex;
		flex-direction: column;
		justify-content: center;
	}

	.order-item {
		border-bottom: #eee 1px solid;
	}

	.order-item:last-child {
		border-bottom: none;
	}

	.good {
		display: flex;
		justify-content: flex-start;
		align-items: stretch;
	}

	.good-img {
		width: 80px;
		padding: 10px;
	}

	.good-info {
		padding: 10px 0;
		width: 140px;
	}

	.good-verifies {
		display: flex;
		flex-grow: 1;
		flex-direction: column;
		justify-content: space-around;
		border-left: #eee 1px solid;
	}

	.verify {
		border-bottom: #eee 1px solid;
		padding: 10px;
	}

	.verify span {
		margin-right: 10px;
	}

	.good-verifies .verify:last-child {
		border-bottom: none;
	}

	.verify-header {
		margin-bottom: 10px;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.verify-multiple {
		margin-bottom: 10px;
	}

	.row-edit-input {
		margin-bottom: 10px;
	}

	.order-item-extend {
		padding: 10px;
	}

	.quick-form {
		margin-bottom: 10px;
	}

	.el-button-group+.el-button-group {
		margin-left: 10px;
	}

	.el-link+.el-link {
		margin-left: 10px;
	}

	.el-tag--dark {
		border: none;
	}

	.flex {
		display: flex;
		align-items: center;
	}

	.photo {
		width: 300px;
	}
</style>
